import React, { Component } from 'react'
import onClickOutside from 'react-onclickoutside'
import MessageUtils from '../../util/MessageUtils'
import SelectUI from './SelectUI.js'

class SelectSingleSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  render() {
    let optionList = this.props.optionList
    if (this.props.removeKey && optionList && optionList.length > 0 && optionList[0].value !== '-1') {
      optionList.unshift({value: '-1', label: MessageUtils.getMessageValue(this.props.messageList, this.props.removeKey)})
    }
    return (
      <SelectUI
        messageList={this.props.messageList}
        optionList={optionList}
        onChange={this.onChange}
        menuIsOpen={this.props.menuIsOpen}
        selectedKey={this.props.selectedKey ? this.props.selectedKey : '-1'}
        placeholder={this.props.placeholder}
        placeholderKey={this.props.placeholderKey}
        isMulti={false}
      />
    )
  }

  handleClickOutside = event => {
    if (this.props.onClickOutside)
      this.props.onClickOutside()
  }

  onChange = (option) => {
    this.props.onChange(option.value)
  }
}

export default onClickOutside(SelectSingleSF)
